'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(require('prop-types'));
var React = require('react');
var React__default = _interopDefault(React);
var R = require('ramda');
var toAmount = require('./to-amount.js');

/**
 * @name createAmountComponent
 * @desc Create `<Currency/>` component.
 * @param {Object} options
 * @param {CurrencyDefinition[]} options.currencies
 * @returns {ReactStatelessComponent} Currency React component
 * @example
 * import { createAmountComponent, EUR, USD } from '@rushplay/common'
 *
 * export const BALLS = {
 *   code: 'BALLS',
 *   ratio: 100,
 *   customCurrency: true,
 * }
 *
 * export default createAmountComponent({
 *   currencies: [EUR, USD, BALLS],
 * })
 */

function createAmountComponent(options) {
  if (!options.currencies) {
    throw new Error('options.currencies is required');
  }

  var currencies = R.indexBy(R.prop('code'), options.currencies);

  function Amount(props) {
    if (process.env.NODE_ENV !== 'production' && props.fixed) {
      // eslint-disable-next-line no-console
      console.warn('DEPRECATED', '`fixed` prop is deprecated. Use `decimals` instead.');
    }

    var decimals = props.decimals || (props.fixed ? 'show' : 'auto');
    return React__default.createElement(props.component, {}, toAmount.toAmount({
      currency: currencies[props.currency] || {},
      locale: props.locale,
      decimals: decimals,
      maximumFractionDigits: props.maximumFractionDigits
    }, props.children));
  }

  Amount.defaultProps = {
    children: 0,
    component: 'span',
    maximumFractionDigits: 2
  };
  Amount.propTypes = {
    children: PropTypes.number,
    className: PropTypes.string,
    component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    currency: PropTypes.oneOf(options.currencies.map(function (_ref) {
      var code = _ref.code;
      return code;
    })),
    decimals: PropTypes.oneOf(['show', 'hide', 'auto']),
    fixed: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    maximumFractionDigits: PropTypes.number
  };
  return Amount;
}

exports.createAmountComponent = createAmountComponent;
//# sourceMappingURL=create-amount-component.js.map
